import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/layout/PublicLayout";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Section";
import api from "@/lib/api";

export default function Industries() {
  const [industries, setIndustries] = useState([]);
  useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <Seo title="Industries We Serve" description="Dreamzz HR provides recruitment and staffing across hospitality, manufacturing, logistics, retail, healthcare, IT and more industries in Karnataka." />
      <PageHeader eyebrow="Industries" title="Recruitment Across Every Sector" subtitle="Specialised staffing expertise for a wide range of industries across Karnataka." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {industries.map((ind, i) => (
          <Reveal key={ind.slug} delay={i * 25}>
            <Link to={`/industries/${ind.slug}`} data-testid={`industry-${ind.slug}`} className="group glass card-hover rounded-2xl p-6 h-full block">
              <h3 className="font-display font-semibold text-lg group-hover:text-brand-emerald transition-colors">{ind.name}</h3>
              <p className="text-sm text-slate-400 mt-2">{ind.description}</p>
            </Link>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
